import { render, staticRenderFns } from "./MetaInfoBar.vue?vue&type=template&id=ecd1c524&"
import script from "./MetaInfoBar.vue?vue&type=script&lang=js&"
export * from "./MetaInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./MetaInfoBar.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports